export { jsxTable } from './syntax';
